import zh from '@/locales/zh'
import en from '@/locales/en'
import es from '@/locales/es'
import ar from '@/locales/ar'
import pt from '@/locales/pt'
import fr from '@/locales/fr'
import de from '@/locales/de'
import ko from '@/locales/ko'

const messages = {
  zh,
  en,
  es,
  ar,
  pt,
  fr,
  de,
  ko,
  ja: en,
  it: en,
  ru: en,
}

export default messages
